<header class="navbar">
  <a class="brand" routerLink="/" (click)="closeMenu()">
    <img src="assets/img/logos/Logo_Gesvatec_PackCert.png" alt="GESVATEC PackCert" height="64">
  </a>

  <nav id="primary-nav" [class.open]="menuOpen">
    <ng-container *ngFor="let item of menu">
      <a *ngIf="item.ready"
         [routerLink]="item.link"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{ exact: item.link === '/' }"
         (click)="closeMenu()">{{ item.labelKey | translate }}</a>
    </ng-container>

    <!-- Login dentro del desplegable (solo móvil) -->
    <a class="nav-login-mobile" [href]="loginUrl" target="_blank" rel="noopener">
      {{ 'nav.login' | translate }}
    </a>
  </nav>

  <div class="nav-actions">
    <a class="nav-login" [href]="loginUrl" target="_blank" rel="noopener">{{ 'nav.login' | translate }}</a>

    <div class="lang-toggle">
      <button type="button" [class.active]="current === 'es'" (click)="setLang('es')">ES</button>
      <button type="button" [class.active]="current === 'en'" (click)="setLang('en')">EN</button>
    </div>

    <button class="nav-toggle"
            type="button"
            [class.open]="menuOpen"
            (click)="toggleMenu()"
            [attr.aria-expanded]="menuOpen"
            aria-controls="primary-nav"
            aria-label="Menú">
      <span></span><span></span><span></span>
    </button>
  </div>
</header>
